(function () {
	'use strict';
	$(document).ready(function () {

		objectFitImages();

		// Smooth scroll to
		$('.scroll-animation').on('click', function (e) {
			e.preventDefault();

			const href = $(this).attr('href');
			if (href) {
				$("html, body").animate({
					scrollTop: $(href).offset().top
				}, 1000);
			}
		});

		$('.scroll-animation a').on('click', function (e) {
			e.stopPropagation();
		});

		//Linki posiadające podmenu - wyłączenie domyślnego zachowania

		// $("#site-menu li.menu-item-has-children > a, #site-menu-desktop li.menu-item-has-children > a").on('click', function (e) {
		// 	e.preventDefault();
		// });

		$("#site-menu li.menu-item-has-children > ul, #site-menu-desktop li.menu-item-has-children > ul" +
			"#site-menu li.menu-item-has-children > ul > li, #site-menu-desktop li.menu-item-has-children > ul > li").on('click', function (e) {
			e.stopPropagation();
		});

		//Mainmenu - level 1

		$("#site-menu li ul > li.menu-item-has-children").click(function () {
			$(this).toggleClass('open');
			$(this).children('ul').slideToggle();
			$(this).siblings('li').children('ul').slideUp();
		});

		//Mainmenu desktop - level 0

		// $("#site-menu-desktop li.menu-item-has-children").hover(function () {
		// 	$(this).toggleClass('open');
		// 	$(this).siblings('li').removeClass('open');
		// 	$(this).children('ul').stop().fadeToggle();
		// 	$(this).siblings('li').children('ul').fadeOut();
		// });

		$("#site-menu-desktop li.menu-item-has-children").hover(function () {
			$(this).toggleClass('open');
			$(this).children('ul').stop().fadeToggle(function () {
				$(this).siblings('li').children('ul').stop().fadeIn();
			});
		});


		//Menu toggle

		$(".menu-toggle").click(function () {
			$('.menu-overlay').fadeToggle({
				start: function () {
					$(this).css({
						display: "flex"
					})
				}
			}).toggleClass('open');
			$(this).toggleClass("open");
			$('.header .container-site').toggleClass("open");
			$('html').toggleClass('no-scroll');
			var menuVideo = $('.main-menu-media video')[0];
			menuVideo.play();
		});

		$(".menu-close").click(function () {
			$('.menu-overlay').fadeOut().removeClass('open');
			$('.menu-toggle').removeClass("open");
			$('.header .container-site').removeClass("open");
			$('html').removeClass('no-scroll');
			var menuVideo = $('.main-menu-media video')[0];
			menuVideo.pause();
		});

		$('#main-menu').mCustomScrollbar({
			axis: "y",
			mouseWheel: {
				enable: true
			}
		});

		//Search trigger
		$('.search-trigger').click(function () {
			$(this).toggleClass('active');
			$('.search-panel').fadeToggle('active');
			return false;
		});

		$('.swiper-image-links').each(function (index) {
			var swiperImageLinks = new Swiper($(this)[0], {
				loop: false,
				slidesPerView: 4,
				spaceBetween: 30,
				navigation: {
					prevEl: $(this).closest('.image-links').find('.swiper-button-prev'),
					nextEl: $(this).closest('.image-links').find('.swiper-button-next'),
				},
				breakpoints: {
					1440: {
						slidesPerView: 3,
					},
					1024: {
						slidesPerView: 2,
					},
					576: {
						slidesPerView: 1,
					}
				}
			});
		});

		//social-icons-sidebar show/hide
		$('#social-toggle').click(function () {
			$('.social-list').animate({
				height: 'toggle'
			});
		});

		$(document).scroll(function () {
			const y = $(this).scrollTop();
			if (y > 200) {
				$('.aside-social').addClass("show");
			} else {
				$('.aside-social').removeClass("show");
			}
		});


		//Data layers
		function getDefaultDataLayer(el) {
			var dlEvent = $(el).data('dl-event');
			var dlEventCategory = $(el).data('dl-event-category');
			var dlEventAction = $(el).data('dl-event-action');
			var dlEventLabel = $(el).data('dl-event-label');

			var dlObject = {};

			dlObject.event = dlEvent;
			dlObject.eventCategory = dlEventCategory;
			dlObject.eventAction = dlEventAction;

			if (dlEventLabel) {
				dlObject.eventLabel = dlEventLabel;
			}

			window.dataLayer = window.dataLayer || [];
			dataLayer.push(dlObject);
			console.log('dlEvent', dlObject);
		}

		$('.data-layer-click').on('click', function () {
			getDefaultDataLayer(this);
		});

		$('.data-layer-hover').on('mouseenter', function () {
			getDefaultDataLayer(this);
		});

		$('.homepage .section-numbers-bg .swiper-pagination-bullet').on('click', function () {
			window.dataLayer = window.dataLayer || [];
			dataLayer.push({
				'event': 'poznaj',
				'eventCategory': 'Poznaj',
				'eventAction': $(this).text(),
				'eventLabel': 'Strona Główna'
			});
			console.log('dlEvent', {
				'event': 'poznaj',
				'eventCategory': 'Poznaj',
				'eventAction': $(this).text(),
				'eventLabel': 'Strona Główna'
			});
		});

		$('#cf-name, #cf-surname, #cf-phone, #cf-email').on('focus', function () {
			var dlFormType = $(this).closest('form').find('input[name=cf-form-type]').val();
			var dlFieldName = $(this).parent().siblings('label').text();

			window.dataLayer = window.dataLayer || [];
			dataLayer.push({
				'event': 'poleFormularza' + dlFormType,
				'nazwaPola': dlFieldName,
				'kliknieciePola': true,
			});
			console.log('dlEvent', {
				'event': 'poleFormularza' + dlFormType,
				'nazwaPola': dlFieldName,
				'kliknieciePola': true,
			});
		});

		$('#cf-name, #cf-surname, #cf-phone, #cf-email').on('focusout', function () {
			var dlFormType = $(this).closest('form').find('input[name=cf-form-type]').val();
			var dlFieldName = $(this).parent().siblings('label').text();
			var dlFieldValid;

			if ($(this).attr('id') == 'cf-name') {
				dlFieldValid = $(this).val() ? true : false;
			}

			if ($(this).attr('id') == 'cf-surname') {
				dlFieldValid = $(this).val() ? true : false;
			}

			if ($(this).attr('id') == 'cf-phone') {
				dlFieldValid = validatePhone($(this).val()) ? true : false;
			}

			if ($(this).attr('id') == 'cf-email') {
				dlFieldValid = validateEmail($(this).val()) ? true : false;
			}

			window.dataLayer = window.dataLayer || [];
			dataLayer.push({
				'event': 'poleFormularza' + dlFormType,
				'nazwaPola': dlFieldName,
				'kliknieciePola': false,
				'prawidloweWypelnienie': dlFieldValid
			});
			console.log('dlEvent', {
				'event': 'poleFormularza' + dlFormType,
				'nazwaPola': dlFieldName,
				'kliknieciePola': false,
				'prawidloweWypelnienie': dlFieldValid
			});
		});

		//Form logic
		async function sendContactForm() {
			var currDate = new Date();

			//Pola obligatoryjne
			var offerUserSelectFirstName = $('input[name=cf-name]').val();
			var offerUserSelectFamilyName = $('input[name=cf-surname]').val();
			var offerUserSelectCompany = $('input[name=cf-company]').val();
			var offerUserSelectPhone = $('input[name=cf-phone]').val();
			var offerUserSelectEmail = $('input[name=cf-email]').val();

			var cYear = currDate.getFullYear();
			var cMonth = ("0" + (currDate.getMonth() + 1)).slice(-2);
			var cDay = ("0" + currDate.getDate()).slice(-2);
			var offerUserSelectCreationDate = cYear + '-' + cMonth + '-' + cDay;

			var offerUserSelectConsentPhone = $('input[name=cf-consent-phone]:checked').val() ? 'true' : 'false';
			var offerUserSelectConsentEmail = $('input[name=cf-consent-email]:checked').val() ? 'true' : 'false';
			var offerUserSelectLeadType = $('input[name=cf-lead-type]').val();
			var offerUserSelectLeadSource = $('input[name=cf-lead-source]').val();
			var offerUserSourceWWW = $('input[name=cf-source-www]').val();

			//Email fields
			var emailFormUserSelectName = $('input[name=email-name]').val();
			var emailFormUserSelectContent = $('textarea[name=email-content]').val();

			//Pola opcjonalne
			var offerUserSelectCampaingName = $('input[name=offer-user-select]:checked').data('campaing-name') ? $('input[name=offer-user-select]:checked').data('campaing-name') : 'BRAK';
			var offerUserSelectContractDuration = $('input[name=offer-user-select]:checked').data('contract-duration');
			var offerUserSelectCampaingType = $('input[name=offer-user-select]:checked').data('campaing-type');

			var offerUserSelectEmobilityPartner = $('input[name=emobility-partner]:checked').val() ? $('input[name=emobility-partner]:checked').val() : 'BRAK';

			//var offerUserSelectWantWallbox = $('input[name=want-wallbox]:checked').val() ? 'true' : 'false';
			var offerUserSelectWallboxType = $('input[name=wallbox-type]:checked').val();

			if (offerUserSelectWallboxType) {
				var offerUserSelectWallboxPower = $('input[name=wallbox-power]:checked').val();
				var offerUserSelectWallboxColor = $('input[name=wallbox-color]:checked').val();
				var offerUserSelectWallboxNumber = $('input[name=wallbox-number]').val();
				var offerUserSelectWallboxInstallation = $('input[name=wallbox-installation]:checked').val() ? 'true' : 'false';
			}

			//Pola UTM
			var offerUserUtmCampaigns = $('input[name=cf-utm-campaigns]').val();
			var offerUserUtmMedium = $('input[name=cf-utm-medium]').val();
			var offerUserUtmSource = $('input[name=cf-utm-source]').val();

			//Data layers
			var dlEvent = $('#cf-submit').data('dl-event');
			var dlEventAction = $('#cf-submit').text().trim();
			var dlEventLabel = $('.top h1').text() ? $('.top h1').text() : 'Strona główna';

			//B2B or B2C form type
			var offerUserSelectFormType = $('input[name=cf-form-type]').val();

			var offerUserDetails = {
				"first_name": offerUserSelectFirstName,
				"family_name": offerUserSelectFamilyName,
				"company_name": offerUserSelectCompany,
				"phone": offerUserSelectPhone,
				"e_mail": offerUserSelectEmail,
				"creation_date": offerUserSelectCreationDate,
				"consent_phone": offerUserSelectConsentPhone,
				"consent_email": offerUserSelectConsentEmail,
				"lead_type": offerUserSelectLeadType,
				"lead_source": offerUserSelectLeadSource,
				"source_www": offerUserSourceWWW,

				"additional_consents": {},

				"campaign_name": offerUserSelectCampaingName,
				"contract_duration": offerUserSelectContractDuration,
				"campaign_type": offerUserSelectCampaingType,

				"emobility_partner": offerUserSelectEmobilityPartner,

				//"wallbox": offerUserSelectWantWallbox,
				"wallbox_type": offerUserSelectWallboxType,
				"wallbox_power": offerUserSelectWallboxPower,
				"wallbox_color": offerUserSelectWallboxColor,
				"wallbox_number": offerUserSelectWallboxNumber,
				"wallbox_installation": offerUserSelectWallboxInstallation,

				"utm_campaign": offerUserUtmCampaigns,
				"utm_medium": offerUserUtmMedium,
				"utm_source": offerUserUtmSource
			}
			var emailFormDetails = {
				"email_name": emailFormUserSelectName,
				"email_content": emailFormUserSelectContent
			}

			const additional_consents = $('input[type="checkbox"].additional-consent');
			additional_consents.each(function () {
				const title = $(this).data('consent-title');
				const key = $(this).attr('id');
				const value = $(this).is(':checked') ? 'true' : 'false';
				offerUserDetails['additional_consents'][key] = {title: title, value: value};
			});

			var offerUserDetailsJSON = JSON.stringify(offerUserDetails);
			var emailFormDetailsJSON = JSON.stringify(emailFormDetails);

			console.log(offerUserDetailsJSON);
			console.log(emailFormDetailsJSON);
			console.log(offerUserSelectFormType);

			const token = await request_captcha('send_chosed_offer');

			$.ajax({
				url: "/wp-admin/admin-ajax.php",
				method: "post",
				timeout: 10000,
				data: {
					action: "send_chosed_offer",
					offerUserSelectFormType: offerUserSelectFormType,
					offerUserDetailsJSON: offerUserDetailsJSON,
					emailFormDetailsJSON: emailFormDetailsJSON,
					email: $('#send_to_email').val(),
					token: token
				},
				success: function (data) {
					if (data == '200') {
						$('.contactpage-form-popup').fadeIn({
							start: function () {
								$(this).css({
									display: "flex"
								})
							}
						});
						$("#formularz-kontaktowy").trigger("reset");


						window.dataLayer = window.dataLayer || [];
						dataLayer.push({
							'event': dlEvent,
							'eventCategory': 'Wyślij',
							'eventAction': dlEventAction,
							'eventLabel': dlEventLabel
						});
						console.log('dlEvent', {
							'event': dlEvent,
							'eventCategory': 'Wyślij',
							'eventAction': dlEventAction,
							'eventLabel': dlEventLabel
						});
					} else {
						console.log(data);
						$('#formularz-kontaktowy .ajax-error').slideDown();
					}
				},
				error: function (data) {
					console.log('AJAX Error: ' + data.status, data.statusText);
					$('#formularz-kontaktowy .ajax-error').slideDown();
				},
				beforeSend: function () {
					$('#formularz-kontaktowy .ajax-success').slideUp();
					$('#formularz-kontaktowy .ajax-loading').slideDown();
					$('#formularz-kontaktowy .ajax-error').slideUp();
				},
				complete: function () {
					$('#formularz-kontaktowy .ajax-loading').slideUp();
				},
			});

		}

		$(document).on('click', '#cf-category', function () {
			$('.info-wrap').find('p').hide();
			let value = $('select[name="cf-category"] :selected').attr('id');
			$('.info-wrap').find('p#' + value).show();
		});

		$('#cf-category option').each(function () {
			if ((!$(this).hasClass('category-label')) && (!$(this).hasClass('business'))) {
				if (!($(this).parent().is('span'))) {
					$(this).wrap('<span>');
				}
			}
		});

		$(document).on('click', '#contactpage-form .radios', function (e) {
			const value = document.querySelector('input[name="cf-client"]:checked').value;
			// $('#cf-category option').hide();
			$('#cf-category option').each(function () {
				if (!$(this).hasClass('category-label')) {
					if (!($(this).parent().is('span'))) {
						$(this).wrap('<span>');
					}
				}
			});
			$('.cf-client-id-hidden').show();

			//reset fields on form change - begin
			$('#cf-client-id').val('');
			$('#cf-name-contact').val('');
			$('#cf-surname').val('');
			$('#cf-phone').val('');
			$('#cf-email').val('');
			$('#cf-category').prop('selectedIndex', 0);
			$('#cf-message').val('');
			$('#file-upload').val('');
			$('.custom-file-upload').html('<strong>Załącznik</strong><br>(opcjonalnie)');
			$('#cf-consent-phone').removeAttr('checked');
			$('#cf-consent-email').removeAttr('checked');
			//reset fields on form change - end

			if (value === 'Klient biznesowy') {
				// $('#cf-category option.business').show();
				$('#cf-category option.business').each(function () {
					if (($(this).parent().is('span'))) {
						$(this).unwrap();
					}
				});
				$('#business-mail').prop('checked', true)
			}
			if (value === 'Klient indywidualny') {
				// $('#cf-category option.individual').show();
				$('#cf-category option.individual').each(function () {
					if (($(this).parent().is('span'))) {
						$(this).unwrap();
					}
				});
				$('#individual-mail').prop('checked', true)
			}
			if (value === 'Fotowoltaika') {
				$('.cf-client-id-hidden').hide();
				// $('#cf-category option.photovoltaic').show();
				$('#cf-category option.photovoltaic').each(function () {
					if (($(this).parent().is('span'))) {
						$(this).unwrap();
					}
				});
				$('#photovoltaic-mail').prop('checked', true)
			}
			if (value === 'Pompy ciepła') {
				$('.cf-client-id-hidden').hide();
				// $('#cf-category option.heat_pump').show();
				$('#cf-category option.heat_pump').each(function () {
					if (($(this).parent().is('span'))) {
						$(this).unwrap();
					}
				});
				$('#heat-pump-mail').prop('checked', true)
			}
			if (value === 'Dystrybucja') {
				// $('#cf-category option.distribution').show();
				$('#cf-category option.distribution').each(function () {
					if (($(this).parent().is('span'))) {
						$(this).unwrap();
					}
				});
				$('#distribution-mail').prop('checked', true)
			}
			if (value === 'Emobility') {
				// $('#cf-category option.emobility').show();
				$('#cf-category option.emobility').each(function () {
					if (($(this).parent().is('span'))) {
						$(this).unwrap();
					}
				});
				$('#emobility-mail').prop('checked', true)
			}
			$('.info-wrap p').hide();
		});

		//Form logic
		async function sendContactFormContactPage() {
			var currDate = new Date();


			var fd = new FormData();
			fd.append('file', $('input[name=cf-file]')[0].files[0]);
			fd.append('action', 'send_contactform_page');
			fd.append('topic', $("input[name='cf-client']:checked").val());
			fd.append('message', $('textarea[name=cf-message]').val());
			fd.append('receive_email', $('#cf-category').find('option:selected').data('mail'));
			fd.append('consent_email', $('input[name=cf-consent-email]:checked').val() ? 'true' : 'false');
			fd.append('consent_phone', $('input[name=cf-consent-phone]:checked').val() ? 'true' : 'false');
			fd.append('category', $('#cf-category').val());
			fd.append('e_mail', $('input[name=cf-email]').val());
			fd.append('phone', $('input[name=cf-phone]').val());
			fd.append('company_name', $('input[name=cf-company]').val());
			fd.append('family_name', $('input[name=cf-surname]').val());
			fd.append('first_name', $('input[name=cf-name-contact]').val());
			fd.append('client_id', $('input[name=cf-client-id]').val());

			const token = await request_captcha('send_contactform_page');
			fd.append('token', token);

			$.ajax({
				type: "POST",
				url: "/wp-admin/admin-ajax.php",
				data: fd,
				contentType: false,
				processData: false,

				success: function (data) {
					if (data == '200') {
						$('.contactpage-form-popup').fadeIn({
							start: function () {
								$(this).css({
									display: "flex"
								})
							}
						});
						$("#contactpage-form").trigger("reset");
					} else {
						$('#contactpage-form .ajax-error').slideDown();
					}
				},
				error: function (data) {
					console.log('AJAX Error: ' + data.status, data.statusText);
					$('#contactpage-form .ajax-error').slideDown();
				},
				beforeSend: function () {
					$('#contactpage-form .ajax-loading').slideDown();
					$('#contactpage-form .ajax-error').slideUp();
					$('#contactpage-form-popup').fadeOut();
				},
				complete: function () {
					$('#contactpage-form .ajax-loading').slideUp();
				},
			});

		}

		$('.contactpage-form-popup-close').on('click', function (e) {
			e.preventDefault();
			$('.contactpage-form-popup').fadeOut();
		});

		function validatePhone(phone) {
			const re = /^[0-9+-\\(\\)\\ \\#]{1,12}$/;
			return re.test(String(phone));
		}

		//console.log(validatePhone('+4#6-4 64(7)'));

		function validateEmail(email) {
			const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(String(email).toLowerCase());
		}

		$('input[name=wallbox-type]:checkbox').change(function () {
			if ($('input[name=wallbox-type]:checked').val()) {
				$('.charger-install').slideDown();
				$(this).closest('li').siblings().find('input[name=wallbox-type]').prop('checked', false);
			} else {
				$('.charger-install').slideUp();
			}
		});

		$('input[name=emobility-partner]:checkbox').change(function () {
			$(this).closest('tr').siblings().find('input[name=emobility-partner]').prop('checked', false);
		});

		$('.subpage .tabs-forms .decrease').on('click', function () {
			var wallbox_number = parseInt($('input[name=wallbox-number]').val());
			if (wallbox_number > 0) {
				wallbox_number--;
				$('.subpage .tabs-forms input[name=wallbox-number]').val(wallbox_number);
				$('.subpage .tabs-forms .wallbox-number').text(wallbox_number);
			}
		});

		$('.subpage .tabs-forms .increase').on('click', function () {
			var wallbox_number = parseInt($('input[name=wallbox-number]').val());
			wallbox_number++;
			$('.subpage .tabs-forms input[name=wallbox-number]').val(wallbox_number);
			$('.subpage .tabs-forms .wallbox-number').text(wallbox_number);
		});

		$(document).on('click', '#cf-submit-disabled', function (e) {
			e.preventDefault();
		});

		$(document).on('click', '#contactpage-form-submit-disabled', function (e) {
			e.preventDefault();
		});

		$(document).on('click', '#cf-submit', function (e) {
			e.preventDefault();
			$('.cf-error').hide();

			var isAllValid = true;


			if ($('#send_to_email').val()) {

				if (!$('#email-content').val()) {
					$('#email-content').siblings('.cf-error').slideDown();
					isAllValid = false;
				}
				if (!$('#email-name').val()) {
					$('#email-name').siblings('.cf-error').slideDown();
					isAllValid = false;
				}

			} else {

				if (!$('#cf-name').val()) {
					$('#cf-name').siblings('.cf-error').slideDown();
					isAllValid = false;
				}

				if (!$('#cf-surname').val()) {
					$('#cf-surname').siblings('.cf-error').slideDown();
					isAllValid = false;
				}
			}

			if (($('#cf-consent-phone').is(':checked')) || ($('#cf-consent-email').is(':checked'))) {

				if ($('#cf-consent-phone').is(':checked')) {
					if (validatePhone($('#cf-phone').val()) === false) {
						$('#cf-phone').siblings('.cf-error').slideDown();
						isAllValid = false;
					}
				}

				if ($('#cf-consent-email').is(':checked')) {
					if (validateEmail($('#cf-email').val()) === false) {
						$('#cf-email').siblings('.cf-error').slideDown();
						isAllValid = false;
					}
				}

			} else {
				$('#cf-consent-phone').siblings('.cf-error').slideDown();
				$('#cf-consent-email').siblings('.cf-error').slideDown();
				isAllValid = false;
			}

			$('input[type="checkbox"].required').each(function () {
				if (!$(this).is(':checked')) {
					$(this).siblings('.cf-error').slideDown();
					isAllValid = false;
				}
			})


			if (!isAllValid) {
				return;

			}

			sendContactForm();
		});

		$(document).on('click', '#contactpage-form-submit', function (e) {
			e.preventDefault();
			$('.cf-error').hide();
			var isAllValid = true;

			if ((!$('#cf-client-id').val()) && (document.querySelector('input[name="cf-client"]:checked').value !== 'Fotowoltaika') && (document.querySelector('input[name="cf-client"]:checked').value !== 'Pompy ciepła')) {
				$('#cf-client-id').siblings('.cf-error').slideDown();
				isAllValid = false;
			}

			if (!$('#cf-name-contact').val()) {
				$('#cf-name-contact').siblings('.cf-error').slideDown();
				isAllValid = false;
			}

			if (!$('#cf-surname').val()) {
				$('#cf-surname').siblings('.cf-error').slideDown();
				isAllValid = false;
			}

			if (validatePhone($('#cf-phone').val()) === false) {
				$('#cf-phone').siblings('.cf-error').slideDown();
				isAllValid = false;
			}

			if (validateEmail($('#cf-email').val()) === false) {
				$('#cf-email').siblings('.cf-error').slideDown();
				isAllValid = false;
			}
			if (!$('#cf-category').val()) {
				$('#cf-category').siblings('.cf-error').slideDown();
				isAllValid = false;
			}
			if (!$('#cf-consent-email').is(':checked')) {
				$('#cf-consent-email').siblings('.cf-error').slideDown();
				isAllValid = false;
			}
			if (!$('#cf-consent-phone').is(':checked')) {
				$('#cf-consent-phone').siblings('.cf-error').slideDown();
				isAllValid = false;
			}


			if (!isAllValid) {
				return;
			}

			sendContactFormContactPage();
		});

		$('#file-upload').change(function () {
			var i = $(this).prev('label').clone();
			var file = $('#file-upload')[0].files[0].name;
			$(this).prev('label').text(file);
		});

		$(document).on('click', '#contactpage-form .expand', function (e) {
			e.preventDefault();
			$(this).siblings('label').children('p:not(:first-child)').slideToggle();
			var text = $(this).text();
			$(this).text(text == "rozwiń" ? "zwiń" : "rozwiń");
		});

		$(document).on('click', '#formularz-kontaktowy .expand', function (e) {
			e.preventDefault();
			$(this).siblings('label').children('p:not(:first-child)').slideToggle();
			var text = $(this).text();
			$(this).text(text == "rozwiń" ? "zwiń" : "rozwiń");
		});

		$('.link-tiles-contact a').on('click', function () {
			var itemIndex = $(this).parent().index();

			$('.contact-page .tab-pane').find('form, form input, form button, form .contactpage-form-popup').each(function () {
				if ($(this).attr('id')) {
					var currId = $(this).attr('id');
					var newId = currId.replace('-disabled', '') + '-disabled';
					$(this).attr('id', newId);
				}

				if ($(this).attr('name')) {
					var currName = $(this).attr('name');
					var newName = currName.replace('-disabled', '') + '-disabled';
					$(this).attr('name', newName);
				}
			});


			$('.contact-page .tab-pane').eq(itemIndex).find('form, form input, form button, form .contactpage-form-popup').each(function () {

				if ($(this).attr('id')) {
					var currId = $(this).attr('id');
					$(this).attr('id', currId.replace('-disabled', ''));
				}

				if ($(this).attr('name')) {
					var currName = $(this).attr('name');
					$(this).attr('name', currName.replace('-disabled', ''));
				}
			});


		});

		$('.category-collapse').on('shown.bs.collapse', function () {
			$(this).find('button:not(.collapsed)')[0].scrollIntoView({
				behavior: 'smooth'
			});
		});


		/**
		 * Execute a function given a delay time
		 *
		 * @param {type} func
		 * @param {type} wait
		 * @param {type} immediate
		 * @returns {Function}
		 */
		var debounce = function (func, wait, immediate) {
			var timeout;
			return function () {
				var context = this, args = arguments;
				var later = function () {
					timeout = null;
					if (!immediate) func.apply(context, args);
				};
				var callNow = immediate && !timeout;
				clearTimeout(timeout);
				timeout = setTimeout(later, wait);
				if (callNow) func.apply(context, args);
			};
		};


		(function () {
			let searchTerm;

			$('#accordion_search_bar').on('change keyup paste', debounce(function (e) {
					searchTerm = $(this).val().toLowerCase();
					if (searchTerm) {
						$('.faq').find(".question-collapse").collapse('hide');
						$('.category-card, .question-card').hide();

						$('.category-card').each(function () {

							let containsText = false;

							$(this).find('.question-card').each(function () {

								const text = $(this).find('button.child').text().toLowerCase();

								if (text.includes(searchTerm)) {
									$(this).show();
									containsText = true;
								}

							});


							if (containsText) {
								$(this).show();
								$(this).find('.category-collapse').collapse('show');
							}

						});
					} else {
						$('.faq').find(".category-collapse").collapse('hide');
						$('.category-card, .question-card').show();
					}
				}, 400)
			);

		}());


	});
}(jQuery));
